<template>
  <v-container v-if="currentProfile" fill-height fluid>
    <v-layout justify-center wrap>
      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 class="text-xs-center text-sm-left">
            <div class="headline font-weight-thin">
              {{ currentProfile.listTitle }}
            </div>
            <div class="subheading font-weight-thin" style="color:#CCC">
              {{ generatedSubHeading() }}
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout
              row
              class="text-xs-center text-sm-right"
              style="width:100%"
            >
              <v-spacer />
              <v-layout column class="pt-2">
                <v-layout
                  row
                  class="heading text-xs-center text-sm-right font-weight-medium"
                >
                  <v-spacer />Charitable Contribution
                  <v-spacer class="hidden-md-and-up" />
                </v-layout>
                <v-layout row class="text-xs-center text-sm-right">
                  <v-spacer />
                  <v-icon color="#ee1d23">mdi-charity</v-icon>
                  <div class="title ml-2">
                    {{ currentProfile.contributionDetails }}
                  </div>
                  <v-spacer class="hidden-md-and-up" />
                </v-layout>
              </v-layout>
              <v-spacer class="hidden-md-and-up" />
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm6 lg4>
                <v-img :src="currentProfile.imageUrl" width="100%" />
                <v-container>
                  <v-layout column align-center justify-center>
                    <!-- OLD CALL RAIL CODE -->
                    <!-- <template
                      v-if="
                        !currentProfile.buttonText ||
                          currentProfile.buttonText == ''
                      "
                    >-->
                    <template
                      v-if="
                        currentProfile.callRailPhone &&
                          currentProfile.callRailPhone !== ''
                      "
                    >
                      <a
                        :href="`tel:${currentProfile.callRailPhone}`"
                        style="color:black !important"
                      >
                        <v-layout row class="mt-1 mb-1">
                          <div class="headline heading mr-3">CALL US</div>
                          <div class="headline">
                            <v-icon color="#000" style="padding-bottom:2px"
                              >mdi-phone</v-icon
                            >
                            <span style="color:#000">{{
                              currentProfile.callRailPhone
                            }}</span>
                          </div>
                        </v-layout>
                      </a>
                    </template>
                    <div class="headline heading" style="text-align: center;">
                      <!-- Affiliate Button -->
                      <template
                        v-if="
                          currentProfile.affiliateButtonLink &&
                            currentProfile.affiliateButtonLink !== '' &&
                            currentProfile.affiliateButtonVisible
                        "
                      >
                        <v-btn
                          large
                          color="#4dc8ed"
                          style="color: white;"
                          @click="
                            contactFormDialog = true;
                            fillFormData('contactEnquiry');
                          "
                          >{{ currentProfile.affiliateButtonText }}</v-btn
                        >
                        <br />
                        <div class="caption" style="color: #58595b !important;">
                          {{ currentProfile.affiliateButtonSubText }}
                        </div>
                      </template>
                      <!-- Email Button -->
                      <template v-if="currentProfile.emailButtonVisible">
                        <v-btn
                          large
                          dark
                          style="width: 262px;"
                          color="#4dc8ed"
                          @click="
                            emailFormDialog = true;
                            fillFormData('emailEnquiry');
                          "
                        >
                          <v-icon left>mdi-email-outline</v-icon>
                          {{
                            $defaultText(
                              "EMAIL NOW",
                              currentProfile,
                              "buttonText"
                            )
                          }}
                        </v-btn>
                        <template
                          v-if="
                            currentProfile.buttonSubText &&
                              currentProfile.buttonSubText !== ''
                          "
                        >
                          <br />
                          <div
                            class="caption"
                            style="color: #58595b !important;"
                          >
                            {{ currentProfile.buttonSubText }}
                          </div>
                        </template>
                      </template>
                      <template v-if="user.auth">
                        <v-btn
                          large
                          dark
                          style="width: 262px;"
                          color="#4dc8ed"
                          @click="
                            testimonialFormDialog = true;
                            fillFormData('testimonial');
                          "
                        >
                          <v-icon left>mdi-star</v-icon>Leave a Testimonial
                        </v-btn>
                      </template>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex xs12 sm6 lg8>
                <div class="headline heading">Who we are</div>
                <div class="body-1">{{ currentProfile.whoAreWe }}</div>
                <div class="headline heading mt-4">About what we do</div>
                <div class="body-1">{{ currentProfile.aboutWhatWeDo }}</div>
                <div class="headline heading" style="margin-top:20px;">
                  <template
                    v-if="
                      currentProfile.servicesHeadingOverride &&
                        currentProfile.servicesHeadingOverride !== ''
                    "
                    >{{ currentProfile.servicesHeadingOverride }}</template
                  >
                  <template v-else>Services</template>
                </div>
                <v-layout row wrap class="pa-3">
                  <v-flex
                    v-for="(service, index) in currentProfile.services"
                    :key="`service_${index}`"
                    class="pa-0"
                    xs12
                    sm6
                  >
                    <li>{{ service }}</li>
                  </v-flex>
                </v-layout>
                <div class="headline heading">Servicing</div>
                <div class="body-1">{{ currentProfile.serviceRegions }}</div>
                <div class="body-1">{{ currentProfile.serviceDistricts }}</div>
                <br />
                <div
                  class="headline heading"
                  v-if="currentProfile.locations != ''"
                >
                  Locations
                </div>
                <div class="body-1" v-if="currentProfile.locations != ''">
                  {{ currentProfile.locations }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex v-if="currentProfile.promotionLive" xs12>
            <a :href="currentProfile.destinationUrl" target="_tab">
              <v-img
                v-if="!$vuetify.breakpoint.xs"
                style="cursor: pointer; border-radius: 5px;"
                :src="currentProfile.desktopUrl"
              />
              <v-img
                v-else
                style="cursor: pointer; border-radius: 5px;"
                :src="currentProfile.mobilUrl"
              />
            </a>
          </v-flex>
          <v-flex xs12 v-if="featuredTestimonials.length > 0">
            <div class="headline sectionHeader">
              <template>Featured Testimonials (Full List Below)</template>
            </div>
            <v-carousel
              hide-controls
              touchless
              light
              class="elevation-0 testimonialCarousel"
              interval="10000"
            >
              <v-carousel-item
                v-for="(testimonial, index) in featuredTestimonials"
                :key="index"
                style="text-align: left; height: auto;"
              >
                <p style="font-size: 20px !important; font-weight: 300">
                  "{{ testimonial.message }}"
                </p>
                <p style="font-weight: bold">{{ testimonial.fullName }}</p>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex v-if="currentProfile.learnMore.length > 0" xs12>
            <div class="headline sectionHeader">
              <template>Learn More</template>
            </div>
            <v-layout row wrap>
              <v-flex
                xs12
                sm6
                md4
                v-for="(learnMore, index) in currentProfile.learnMore"
                :key="`learnMore_${index}`"
              >
                <v-card>
                  <v-card-title>
                    <h3>{{ learnMore.title }}</h3>
                  </v-card-title>
                  <v-card-text>
                    <a
                      @click="addClick(learnMore.id)"
                      target="_blank"
                      :href="learnMore.fileLink"
                      >Click here to view PDF info sheet</a
                    >
                  </v-card-text>
                  <v-img
                    style="position: absolute; bottom: 5px; right: 5px; height: 60px; width: 60px; cursor: default;"
                    src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/noun_Info_2510064.png?alt=media&token=2b04c752-59a3-402c-a176-c0c3a35f82a3"
                  />
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <div class="headline sectionHeader">
              <template
                v-if="
                  currentProfile.ourWorkHeadingOverride &&
                    currentProfile.ourWorkHeadingOverride !== ''
                "
                >{{ currentProfile.ourWorkHeadingOverride }}</template
              >
              <template v-else>Our Work</template>
            </div>
            <v-layout row wrap>
              <v-flex
                xs12
                sm6
                md4
                v-for="(work, index) in currentProfile.ourWork"
                :key="`workImage_${index}`"
              >
                <v-card flat tile class="d-flex">
                  <silentbox-single
                    v-if="work.imageUrl"
                    :src="work.imageUrl"
                    :description="work.description"
                  >
                    <v-img :src="work.imageUrl" position="center center" />
                    <div
                      style="width:100%;text-align: center;text-decoration: none !important;"
                    >
                      {{ work.description }}
                    </div>
                  </silentbox-single>
                  <silentbox-single
                    v-else
                    :src="work.videoUrl"
                    :description="work.description"
                  >
                    <v-img
                      :src="
                        `https://img.youtube.com/vi/${work.videoID}/hqdefault.jpg`
                      "
                      aspect-ratio="1.75"
                      position="center center"
                    />
                    <div
                      style="width:100%;text-align: center;text-decoration: none !important;"
                    >
                      {{ work.description }}
                    </div>
                  </silentbox-single>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="testimonials.length > 0" xs12>
            <div class="headline sectionHeader">
              <template>Testimonials</template>
            </div>
            <v-layout row wrap>
              <v-flex
                xs12
                sm6
                md4
                v-for="(testimonial, index) in testimonials"
                :key="index"
              >
                <v-card flat tile style="background: white;" class="d-flex">
                  <v-card-text>
                    <p style="font-size: 20px !important; font-weight: 300">
                      "{{ testimonial.message }}"
                    </p>
                    <p style="font-weight: bold">{{ testimonial.fullName }}</p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!--<pre>{{ currentProfile }}</pre>-->
      </v-container>
    </v-layout>
    <v-dialog v-model="emailFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Email Enquiry</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="salesEnquiryForm">
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.mobile"
                    :rules="[(v) => !!v || 'Phone number is required']"
                    label="Mobile / Phone Number"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Email"
                  />
                  
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.promoCode"
                    label="Promo Code (if you have one)"
                  />
                </v-flex>
                <v-flex xs12>
                  {{
                    $defaultText(
                      "Attach a file",
                      currentProfile,
                      "emailFileDescription"
                    )
                  }}
                  <br />
                  <input type="file" @change="fileChange" />
                </v-flex>
                <v-flex xs12 v-if="files.length > 0">
                  <p class="mb-0" v-for="(file, i) in files" :key="i">
                    {{file.meta.name}}
                  </p>
                  <p class="mt-2">
                                      {{files.length}} attachment{{`${files.length > 1 ? 's' : ''}`}}

                  </p>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="formData.message"
                    :label="`Your message to ${currentProfile.name}`"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="formData.goodCause"
                    :items="goodCauses"
                    item-text="name"
                    item-value="name"
                    label="What area of Impact do you want to support?"
                    placeholder="Please select"
                  />
                </v-flex>
                <!-- Reference Area -->
                <v-flex xs12>
                  <v-select
                    v-model="formData.reference"
                    :items="selectItems"
                    label="How did you hear about us?"
                  />
                  <!-- Other Option -->
                  <v-textarea
                    v-if="formData.reference === 'Other'"
                    v-model="formData.referenceOther"
                    label="Other..."
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  Do you give UpstreamNZ permission to email you seasonally
                  about the impact your purchases are having?*
                  <v-select
                    v-model="formData.permission"
                    :items="['Yes', 'No']"
                    :rules="[(v) => !!v || 'Permission selection is required']"
                  />
                </v-flex>
                <v-flex>
                  <v-checkbox
                    :rules="[
                      (v) =>
                        v ||
                        'You need to agree to the privacy policy to progress',
                    ]"
                    v-model="checkbox"
                    :label="
                      `By sending this email, I agree to the UpstreamNZ 
                  privacy policy. I understand that UpstreamNZ is a copied recipient of this email, 
                  in order to provide evidence that generates impact for our charities.`
                    "
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/upstreamnz-dev.appspot.com/o/UpstreamNZ_combined_T%26C_s___Privacy_Policy.pdf?alt=media&token=ee3bdfa0-ed7b-4b79-83fe-35874289aefb"
                    >Privacy Policy</a
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              emailFormDialog = false;
              formData = {};
            "
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click="sendEmail()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="testimonialFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Leave a Testimonial</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="testimonialForm">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :rules="[(v) => v.length > 3 || 'Please enter a message']"
                    v-model="formData.message"
                    :label="`Your Testimonial for ${currentProfile.name}`"
                    counter="225"
                    maxlength="225"
                    required
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              testimonialFormDialog = false;
              formData = {};
            "
            >Close</v-btn
          >
          <v-btn
            color="blue darken-1"
            flat
            :loading="saving"
            @click="saveTestimonial()"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="contactFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $defaultText("Contact Us", currentProfile, "contactUsHeader") }}
          </span>
        </v-card-title>
        <v-card-text>
          <span>
            {{
              $defaultText(
                `We are sending you to this business' website via an affiliate link that lets them know you came from Upstream so your Good Cause will receive their contribution. Thanks for your support.`,
                currentProfile,
                "contactUsSubheading"
              )
            }}
          </span>
          <v-container grid-list-md>
            <v-form ref="contactForm">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="contactData.fullName"
                    :rules="[(v) => !!v || 'Full Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="contactData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="contactData.goodCause"
                    :items="goodCauses"
                    item-text="name"
                    item-value="name"
                    label="Good Cause you want to support"
                    placeholder="Please select"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              contactFormDialog = false;
              contactData = {};
            "
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click="sendContactForm()"
            >Send</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailFormConfirmation" max-width="350px">
      <v-card>
        <v-card-text>
          Thank you for contacting {{ currentProfile.name }} and creating an
          opportunity for a Good Cause to be impacted.
          {{ currentProfile.name }} shall be in contact with you asap. We are
          happy to help if there is further assistance you need.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="emailFormConfirmation = false"
            >Close</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    checkbox: false,
    formData: {},
    saving: false,
    contactData: {},
    fileData: {},
    includeFileData: false,
    files: [],
    emailFormDialog: false,
    contactFormDialog: false,
    emailFormConfirmation: false,
    testimonialFormDialog: false,
    customRoutes: {
      coffee: "inrvq2lcoW1PV30PsdVH",
      power: "z14vz7TiRWXNLRnKBbFD",
    },
    selectItems: [
      "Another Supplier",
      "Charity Promoted",
      "Facebook",
      "Friend/Family",
      "Google Adwords",
      "Promotion Material",
      "Web Search",
      "YouTube Video",
      "Other",
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      currentProfile: "business/currentProfile",
      goodCauses: "goodCauses/approved",
      keywords: "business/keywords",
      categoriesByName: "categories/byName",
      subCategoriesByName: "categories/subCatByName",
    }),
    testimonials: function() {
      if (this.currentProfile.testimonial) {
        let array = this.currentProfile.testimonial.filter(
          (x) => x.visible == 1 && x.featured != 1
        );
        return array;
      } else {
        return {};
      }
    },
    featuredTestimonials: function() {
      if (this.currentProfile.testimonial) {
        let array = this.currentProfile.testimonial.filter(
          (x) => x.featured == 1
        );
        return array;
      } else {
        return {};
      }
    },
  },
  created() {
    this.$nextTick(function() {
      if (!this.$route.params.hasOwnProperty("id")) {
        this.$route.params.id = "inrvq2lcoW1PV30PsdVH";
      }
      if (this.$route.name === "buy") {
        this.$route.params.id = this.customRoutes[this.$route.params.id];
      }
      if (this.$route.params.hasOwnProperty("keyword")) {
        this.$store.dispatch(
          "business/loadProfileByKeyword",
          this.$route.params.keyword
        );
      } else {
        if (
          !this.currentProfile ||
          this.currentProfile.id !== this.$route.params.id
        ) {
          this.$store.dispatch("business/loadProfile", this.$route.params.id);
        }
      }
    });
  },
  methods: {
    generatedSubHeading() {
      if (this.currentProfile.category) {
        let heading = "|";
        let category = this.currentProfile.category.split(",");
        let subCategory = this.currentProfile.subCategory.split(",");
        category.forEach((cat) => {
          if (typeof this.categoriesByName[cat] != "undefined") {
            heading = `${heading} ${this.categoriesByName[cat].name} |`;
          }
        });
        subCategory.forEach((subCat) => {
          if (typeof this.subCategoriesByName[subCat] != "undefined") {
            heading = `${heading} ${this.subCategoriesByName[subCat].name} |`;
          }
        });
        heading = `${heading} ${this.currentProfile.name} |`;
        return heading;
      }
    },
    addClick(on) {
      let payload = {
        type: "learnMoreClick",
        id: this.currentProfile.id,
        on: on,
      };
      this.$store.dispatch("clicks/saveClick", payload);
    },
    saveTestimonial() {
      if (this.$refs.testimonialForm.validate()) {
        this.saving = true;
        this.formData.business_id = this.currentProfile.id;
        if (typeof this.currentProfile.testimonial !== "undefined") {
          this.formData.idx = this.currentProfile.testimonial.length;
        } else {
          this.formData.idx = 0;
        }
        this.$store
          .dispatch("business/createTestimonial", this.formData)
          .then((testimonial) => {
            this.formData.user_id = this.userData.firebase_id;
            this.saving = false;
            this.testimonialFormDialog = false;
          });
      }
    },
    fillFormData(type) {
      if (this.userData.fullName) {
        if (type === "emailEnquiry") {
          this.formData.goodCause = this.userData.chosenGoodCause;
          this.formData.fullName = this.userData.fullName;
        }
        if (type === "contactEnquiry") {
          this.contactData.fullName = this.userData.fullName;
          this.contactData.email = this.userData.email;
          this.contactData.goodCause = this.userData.chosenGoodCause;
        }
        if (type === "testimonial") {
          this.formData.fullName = this.userData.fullName;
          this.formData.user_id = this.userData.firebase_id;
        }
        if (this.userData.updates == 1) {
          this.formData.permission = "Yes";
        }
        this.formData.email = this.userData.email;
        this.formData.mobile = this.userData.phone;
      }
    },
    fileChange(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      this.fileData.meta = { name: file.name, type: file.type };
      reader.onload = (e) => {
        this.includeFileData = true;
        this.fileData.data = e.target.result;
        this.files.push(JSON.parse(JSON.stringify(this.fileData)));
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    async sendEmail() {
      if (this.$refs.salesEnquiryForm.validate()) {
        this.formData.business_id = this.currentProfile.id;
        if (this.includeFileData === true) {
          this.formData.file = this.files;
        }
        this.$store.dispatch("emailSending/sendSalesEnquiry", this.formData);
        this.emailFormDialog = false;
        this.emailFormConfirmation = true;
      }
    },
    sendContactForm() {
      debugger;
      if (this.$refs.contactForm.validate()) {
        let date = new Date();
        let timeStamp = `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`;
        this.contactData.business_id = this.currentProfile.id;
        this.contactData.timeStamp = timeStamp;
        if (!this.currentProfile.affiliateButtonLink.includes("https://")) {
          // if URL does not contain https:// add it.
          this.currentProfile.affiliateButtonLink = `https://${this.currentProfile.affiliateButtonLink}`;
        }
        if (!this.currentProfile.affiliateButtonLink.includes("?")) {
          this.currentProfile.affiliateButtonLink =
            this.currentProfile.affiliateButtonLink + "?upstreamnz=1";
        }
        this.currentProfile.affiliateButtonLink =
          this.currentProfile.affiliateButtonLink +
          "&fullName=" +
          this.contactData.fullName +
          "&email=" +
          this.contactData.email +
          "&goodCause=" +
          this.contactData.goodCause;
        this.$store.dispatch(
          "emailSending/sendAffiliateLinkNotice",
          this.contactData
        );
        this.$store
          .dispatch("affiliateLinkClicks/save", this.contactData)
          .then(() => {
            this.contactFormDialog = false;
          });
        this.currentProfile.affiliateButtonLink = encodeURI(
          this.currentProfile.affiliateButtonLink
        );
        window.open(
          this.currentProfile.affiliateButtonLink,
          "_blank",
          "location=yes"
        );
      }
    },
    contact() {
      this.currentProfile.affiliateButtonLink = encodeURI(
        this.currentProfile.affiliateButtonLink
      );
      if (this.currentProfile.useContactForm === true) {
        this.contactFormDialog = true;
      } else {
        window.open(
          this.currentProfile.affiliateButtonLink,
          "_blank",
          "location=yes"
        );
      }
    },
  },
};
</script>

<style>
.heading {
  color: #4dc8ed;
}

.application {
  background-color: white !important;
}

.sectionHeader {
  border-bottom: 1px solid #4dc8ed;
  color: #4dc8ed;
}

.nl2br {
  white-space: pre;
}

.testimonialCarousel {
  height: 140px !important;
  margin-top: 20px;
  cursor: default;
}

.v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}

@media only screen and (max-width: 1400px) {
  .testimonialCarousel {
    height: 180px !important;
  }
}

@media only screen and (max-width: 730px) {
  .testimonialCarousel {
    height: 230px !important;
  }
}

@media only screen and (max-width: 460px) {
  .testimonialCarousel {
    height: 270px !important;
  }
}

@media only screen and (max-width: 390px) {
  .testimonialCarousel {
    height: 380px !important;
  }
}

#silentbox-overlay__description {
  color: #4dc8ed !important;
  font-family: "Aleo" !important;
  background: white;
  padding-bottom: 10px;
  border: 1px solid rgb(77, 200, 237);
  font-size: 20pt !important;
}
</style>
